export const favoriteFilterKeys = {
  departments: 'favAdmEmployeesDepartments',
  status: 'favAdmEmployeesStatus',
  //company: 'favAdmEmployeesCompany',
  roles: 'favAdmEmployeesRoles',
  platforms: 'favAdmEmployeesPlatforms',
}
